import * as type from '../actions/types';

const initialState = {
    relatedProjects: [],
    loading: false,
    error: null,
}

export default function relatedProjects(state = initialState, action) {
    switch (action.type) {
        case type.GET_RELATED_PROJECTS_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.GET_RELATED_PROJECTS_SUCCESS:
            return {
                ...state,
                loading: false,
                relatedProjects: action.data,
            }
        case type.GET_RELATED_PROJECTS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}